export default __webpack_public_path__ + "static/media/filters.43be9627.svg";